// extracted by mini-css-extract-plugin
export default {"body":"Nav_body__LTTjr","logo":"Nav_logo__fEmg0","icon":"Nav_icon__1bW+P","item":"Nav_item__SMFyc","item__text":"Nav_item__text__P9+N8","item--active":"Nav_item--active__-x4ID"};